export default {
  signedIn: {
    value: 0,
    name: '签到',
    icon: 'signed-in',
  },
  signBroken: {
    value: 1,
    name: '爽约',
    icon: 'sign-broken',
  },
  cardDeduction: {
    value: 2,
    name: '办卡抵扣',
    icon: 'card-deduction',
  },
  signCanceled: {
    value: 3,
    name: '取消签到',
    icon: 'sign-canceled',
  },
  expired: {
    value: 4,
    name: '积分过期',
    icon: 'expired',
  },
  activity_accumulate: {
    value: 5,
    name: '累计签到挑战',
    icon: 'expired',
  },
};
